'use client';

import { usePathname, useSearchParams } from 'next/navigation';
import { useEffect, useState } from 'react';

// Default to the provided ID if not in env
const FP_PIXEL_ID = process.env.NEXT_PUBLIC_FACEBOOK_PIXEL_ID || '4070137846632304';

export default function FacebookPixel() {
    const pathname = usePathname();
    const searchParams = useSearchParams();
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        // Dynamically import to separate client bundle
        import('react-facebook-pixel')
            .then((x) => x.default)
            .then((ReactPixel) => {
                ReactPixel.init(FP_PIXEL_ID);
                ReactPixel.pageView();
                setLoaded(true);
            });
    }, []);

    useEffect(() => {
        if (!loaded) return;
        import('react-facebook-pixel')
            .then((x) => x.default)
            .then((ReactPixel) => {
                ReactPixel.pageView();
            });
    }, [pathname, searchParams, loaded]);

    return null;
}
